import { FormGroup, FormControl,Validators } from '@angular/forms';
import { Component, Input, Optional, Host } from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';

@Component({
  selector: 'app-inline-edit',
  styleUrls: ['./inline-edit.component.scss'],
  template: `
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="mat-subheading-2">Asignar Sector</div>
    <mat-form-field class="example-full-width">
                                    <mat-label>Sector</mat-label>
                                    <mat-select formControlName = "idSector">
                                        <mat-option  *ngFor="let dato of cboSectores" [value]="dato.idSector" >
                                            {{dato.Nombre_Sector}}
                                        </mat-option>
                                    </mat-select>
   </mat-form-field>

    <div class="actions">
      <button mat-button type="button" color="primary" (click)="onCancel()">Cancelar</button>
      <button mat-button type="submit" color="primary" [disabled]="form.invalid">Guardar</button>
    </div>
  </form>
`
})
export class InlineEditComponent{

    @Input()
    get value(): string { return this._value; }
    set value(x: string) {}
    private _value = '';
    form: FormGroup;

    @Input() cboSectores : any=[];
  
    constructor(@Optional() @Host()
     public popover: SatPopover) {

      this.form = new FormGroup({
        "idSector" :new FormControl("",Validators.required),
      });
      }
  
    onSubmit() {
      if (this.popover) {
        this.popover.close(this.form.controls['idSector'].value);
      }
    }
  
    onCancel() {
      if (this.popover) {
        this.popover.close();
      }
    }


}
